/*global jQuery:false */
var QUEO = window.QUEO ||{};

QUEO.Utils = (function($) {
	
	// Variablen zur Detektion von Events/Devices usw. a la modernizr.js
	var _detectVars = {
		transitionEvent: _whichTransitionEndEvent(),
		isTouchDevice: _isTouchDevice()
	};
	
	// Prüft welche Transition vorhanden ist
	function _whichTransitionEndEvent() {
		var t;
		var el = document.createElement('fakeelement');
		var transitions = {
			'transition':'transitionend',
			'OTransition':'oTransitionEnd',
			'MozTransition':'transitionend',
			'WebkitTransition':'webkitTransitionEnd'
		};

		for(t in transitions){
			if( el.style[t] !== undefined ) {
				return transitions[t];
			}
		}
	}
	
	// Funktion um herauszufinden ob es ein Touch-Device ist
	function _isTouchDevice() {
		var msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture;
		return ( ( 'ontouchstart' in window ) || (window.DocumentTouch && document instanceof DocumentTouch )) ? true : false;// MSFT specific.
	}
	
	// Gibt den aktuellen Viewport zurück
	// natives javascript, da jQuery die falschen Werte mit $(window).innerHeight() usw. zurückgibt
	// 
	// siehe https://andylangton.co.uk/blog/development/get-viewportwindow-size-width-and-height-javascript
	function _getViewport() {
		var e = window, 
			a = 'inner';
		if(!('innerWidth' in window)) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return {width: e[a+'Width'], height: e[a+'Height']};
	}
	
	// Gekapselte Log-Funktion die global über die Konfiguration gesteuert wird.
	// Damit soll verhindert werden das console.log() genutzt wird und event. vergessen wird
	//
	function _log() {
		if (QUEO.Config.debug && window.console && window.console.log) {
			window.console.log.apply(window.console, arguments);
		}
	}
	
	// Diese Funktionen werden nach außen zurückgegeben
	return {
		log: _log,
		whichTransitionEndEvent: _whichTransitionEndEvent,
		getViewport: _getViewport,
		// Objekt mit Angaben zu Touch-Device und Transitionevent
		detectVars: _detectVars
	};

})(jQuery);